<template>
  <section class="photo-upload">
    <input type="file" v-if="isIOS" :disabled="photo.status===1" @click="clickPhoto" @change="photoChange" accept="image/*" ref="file"/>
    <!--<input type="file" v-if="isIOS" @click="clickPhoto" value="1" :disabled="photo.status===1" @change="photoChange" accept="image/*" ref="file"/>-->
    <input type="file" v-else :disabled="photo.status===1" @click="clickPhoto" @change="photoChange" accept="image/*" ref="file" capture="camera"/>
    <!--<input type="file" accept="image/*" capture="camera" />-->
    <img class="photo-img" v-show="photo.url" :src="photo.url" alt="" ref="photo">
    <img class="photo-img" v-show="!photo.url" :src="uploadPhotos[photo.type]" alt="">
    <!--<p class="text" color-primary :class="{'hidden': photo.status!==0}">{{UPLOAD_TEXTS[photo.type]}}</p>-->
    <div class="status" :class="photo.status === 2 || photo.status === 4 ? 'no-mask':''" v-show="photo.status !== 0">
      <div class="status-item">
        <img src="../assets/loading.gif" alt="" v-show="photo.status === 1">
        <i class="iconfont etc-icon-check" color-primary v-show="photo.status === 2 || photo.status === 4"></i>
        <!--<i class="iconfont etc-icon-warn" v-show="photo.status === 3 || photo.status === 4"></i>-->
      </div>
      <p class="status-text" :class="photo.status === 3?'reload':''" v-show="photo.status !== 2 && photo.status !== 4">{{UPLOAD_STATUS_TEXTS[photo.type][photo.status]}}</p>
      <p class="bottom-text" bgc-primary :class="photo.status === 3?'warn':''" v-show="photo.status !== 1">{{uploadErr || UPLOAD_TEXTS[photo.type]}}</p>
    </div>
    <modal ref="modal"></modal>
    <popup ref="popup">
      <div slot="content" class="upload-popup">
        <header v-if="photo.type==='vehicle_front'">上传行驶证（非驾驶证）正页</header>
        <header v-if="photo.type==='vehicle_back'">上传行驶证副页（含核定载人数)</header>
        <p class="tip" v-if="photo.type==='vehicle_front'">无法识别图片中的车牌号，请重新上传行驶证正页（含车牌号码）图片</p>
        <p class="tip" v-if="photo.type==='vehicle_back'">无法识别图片中的车牌号，请重新上传行驶证副页（核定载人数）图片</p>
        <img v-if="photo.type==='vehicle_front'" src="../assets/newApply/upload-vehicle_front.png" alt="">
        <img v-if="photo.type==='vehicle_back'" src="../assets/newApply/upload-vehicle_back.png" alt="">
        <div class="footer">
          <button cool-btn @click="hidePopup">我知道了</button>
        </div>
      </div>
    </popup>
  </section>
</template>

<script>
// import ApplyApi from '@/api/apply.api'
// mixin
import FunMixin from '@/mixins/funMixin'
// components
import Modal from '@/components/cool.modal'
import Popup from '@/components/cool.popup'
// utils
// 压缩
import lrz from 'lrz/dist/lrz.bundle'
import reconApply from '@/api/reconApply.api'
import {mapState, mapMutations} from 'vuex'

const STATUS_TEXT = ['', '证件识别中', '识别成功', '重新上传', '上传成功']
const NO_OCR_STATUS_TEXT = ['', '上传中', '上传成功', '重新上传', '上传成功']
const UPLOAD_PHOTOS = {
  idcard_front: require('../assets/apply/idcard_front.png'),
  idcard_back: require('../assets/apply/idcard_back.png'),
  idcard_hold: require('../assets/apply/idcard_hold.png'),
  vehicle_front: require('../assets/apply/vehicle_front.png'),
  vehicle_back: require('../assets/apply/vehicle_back.png'),
  vehicle_car: require('../assets/apply/vehicle_car.png')
}
const UPLOAD_TEXTS = {
  idcard_front: '人面像',
  idcard_back: '国徽面',
  idcard_hold: '自拍手持身份证照',
  vehicle_front: '行驶证(印章页)',
  vehicle_back: '行驶证(条码页)',
  vehicle_car: '车头照(含车牌)'
}
const UPLOAD_STATUS_TEXTS = {
  idcard_front: STATUS_TEXT,
  idcard_back: STATUS_TEXT,
  idcard_hold: NO_OCR_STATUS_TEXT,
  vehicle_front: STATUS_TEXT,
  vehicle_back: STATUS_TEXT,
  vehicle_car: NO_OCR_STATUS_TEXT
}
const ERR_TIP = {
  idcard_front: {
    default: '无法识别身份证姓名',
    name: '无法识别身份证姓名',
    number: '无法识别身份证号码'
  },
  idcard_back: {
    default: '无法识别证件有效期',
    valid_date: '无法识别证件有效期'
  },
  vehicle_front: {
    // 无法识别车牌号码
    default: '无法识别车牌号码',
    plate_no: '无法识别车牌号码'
  },
  vehicle_back: {
    default: '无法识别核定载人数',
    passengers: '无法识别核定载人数'
  }
}
const ERR_POPUP = ['vehicle_front', 'vehicle_back']

let customData = {
  oldStatus: ''
}

export default {
  name: 'photoUpload',
  mixins: [FunMixin],
  components: {
    Modal,
    Popup
  },
  props: {
    photo: {
      type: Object,
      default: () => { return {status: 0, type: '', url: ''} }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      uploadTimes: 0,
      uploadErr: '',

      UPLOAD_STATUS_TEXTS,
      UPLOAD_TEXTS,
      isIOS: '',
      startUpload: false,
      uploadPhotos: UPLOAD_PHOTOS
    }
  },
  computed: {
    ...mapState([
      'lastApplyInfo'
    ])
  },
  methods: {
    hidePopup() {
      this.$refs.popup.$emit('hidePopup')
    },
    photoFail() {
      this.photo.status = 3
      this.$refs.file && (this.$refs.file.value = '')
      this.$forceUpdate()
    },
    uploadFail(err = {}) {
      this.photo.status = 3
      this.uploadErr = (ERR_TIP[this.photo.type] || {}).default || ''
      if (ERR_POPUP.indexOf(this.photo.type) > -1 && err.message !== 'code with -1') {
        this.$refs.popup.$emit('showPopup')
      }
      this.$forceUpdate()
    },
    async photoChange() {
      console.log('photoChange')
      try {
        const file = this.$refs.file.files[0]
        console.log('photo file: ', file)
        if (file) {
          let reader = new FileReader()
          reader.readAsDataURL(file) // base64
          reader.onloadend = () => {
            console.log('图片读取成功')
            this.photo.url = reader.result
            this.photo.status = 1
            this.handlePhoto(file)
          }
          reader.onerror = () => {
            console.warn('图片读取失败')
            this.photoFail()
          }
        } else {
          this.photo.status = customData.oldStatus
        }
      } catch (e) {
        this.photoFail()
        console.warn('photo upload catch', e)
      }
    },
    clickPhoto() {
      console.log('clickPhoto', this.appChannel)
      customData.oldStatus = this.photo.status
    },
    async handlePhoto(file) {
      let quality = (1000 / (file.size / 1024)).toFixed(2)
      console.log('start handlePhoto file size', file.size, 'scale', quality)
      // 文件大于 500kb 压缩
      if (file.size / 1024 > 500) {
        // Util.canvasDataURL(this.photo.url, {quality: quality, fileName: this.photo.type + '.jpg'}).then(res => {
        //   console.log('canvas resize 压缩成功 file size', res.file.size)
        //   this.uploadPhoto(res.file || file)
        // })
        lrz(file, {quality: quality}).then(res => {
          console.log('lrz 压缩成功', res.file.size)
          this.uploadPhoto(res.file || file)
        })
      } else {
        this.uploadPhoto(file)
      }
    },
    uploadPhoto(file) {
      console.log('开始图片上传', file, this.lastApplyInf)
      if (this.startUpload) return
      this.startUpload = true
      this.uploadTimes++
      reconApply.userUploadImageToCos({
        type: this.photo.type,
        photo: file
      })
        .then(res => {
          reconApply.userUploadImage({
            type: this.photo.type,
            photo: res.img_url,
            draft_sn: this.lastApplyInfo.draft_sn[this.type]
          }).then(res => {
            this.startUpload = false
            console.log('图片识别完成')
            this.photo.status = res.draft ? 2 : 4
            this.uploadErr = ''

            if (this.photo.type !== 'vehicle_car' && this.uploadTimes < 3) {
              if (res.draft) {
                this.lastApplyInfo.draft_sn[this.type] = res.draft.draft_sn
                this.setLastApplyInfo(this.lastApplyInfo)
                let err = ''
                for (let k in ERR_TIP[this.photo.type]) {
                  if (k !== 'default') {
                    if (!res.draft[k] && !err) {
                      err = ERR_TIP[this.photo.type][k]
                    }
                  }
                }
                err && (this.uploadErr = err)
                err && (this.photo.status = 3)
                if (err && ERR_POPUP.indexOf(this.photo.type) > -1) {
                  this.$refs.popup.$emit('showPopup')
                }
              } else {
                this.uploadFail()
              }
            }
            this.$emit('uploadEnd', this.photo.type !== 'vehicle_car' ? res : {})
          }).catch(err => {
            this.startUpload = false
            console.warn('图片识别失败', err)
            this.uploadFail(err)
            // this.photo.status = err.code ? 3 : 4
            this.$refs.file && (this.$refs.file.value = '')
            this.$emit('uploadEnd', {code: err.code})
          })
        })
    },
    ...mapMutations([
      'setLastApplyInfo'
    ])
  },
  async created() {
    this.isIOS = await this.m_isIOS()
  }
}
</script>

<style scoped lang="scss">
@import "../style/cool.practical";
.photo-upload{
  width: 320px;
  height: 242px;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 20px;
  position: relative;
  .photo-tap,input[type=file]{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 20;
  }
  .photo-img{
    width: 320px;
    height: 242px;
  }
  .text {
    position: absolute;
    bottom: 5px;
    width: 100%;
    font-size: 28px;
    text-align: center;
    z-index: 12;
    &.hidden{
      font-size: 34px;
      color:#ffffff !important;
      bottom: 5px;
    }
  }
  .status{
    text-align: center;
    @extend %mask;
    .status-item{
      margin: 60px auto 0;
      position: relative;
      z-index: 12;
      @extend %flex-center;
      img{
        width: 60px;
        height: 60px;
      }
      .iconfont{
        /*color: #FFFFFF;*/
      }
      .etc-icon-check{
        font-size: 76px;
        background-color: #fff;
        border-radius: 50%;
        width: 70px;
        height: 70px;
        &:before{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
      .etc-icon-warn{
        font-size: 52px;
      }
    }
    .status-text{
      color: #fff;
      font-size: 36px;
      z-index: 12;
      position: relative;
      margin-top: 20px;
      &.reload{
        font-size: 30px;
        display: inline-block;
        width: 200px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border: 2px solid #FFFFFF;
        border-radius: 100px;
        margin-top: 5px;
      }
    }
    .bottom-text{
      height: 52px;
      line-height: 52px;
      width: 100%;
      color: #FFFFFF;
      font-size: 28px;
      position: absolute;
      bottom: 0;
      &.warn{
        background-color: $red-tip-color;
      }
    }
    &.no-mask{
      background-color: transparent;
    }
  }
  .upload-popup{
    padding: 40px 0;
    text-align: center;
    header{
      font-size: 38px;
      font-weight: bold;
      padding: 0 40px;
    }
    .tip{
      font-size: 26px;
      color: #666666;
      line-height: 44px;
      padding: 20px 55px 0;
      text-align: left;
    }
    img{
      width: 547px;
      height: 349px;
      margin-top: 20px;
    }
    .footer{
      margin-top: 40px;
      padding: 0 75px;
    }
  }
}
</style>
